<script setup lang="ts">
import { cn } from '@/lib/utils'
import { CheckCircle2 } from 'lucide-vue-next'
import { Primitive, PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { PaymentTitleHeader, paymentTitleHeader } from '.'

interface Props extends PrimitiveProps {
    variant?: PaymentTitleHeader['variant']
    class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
    as: 'h1',
})
</script>

<template>
    <div class="flex gap-2">
        <svg width="32" v-if="variant === 'pending'" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.0003 29.3327C23.3641 29.3327 29.3337 23.3631 29.3337 15.9993C29.3337 8.63555 23.3641 2.66602 16.0003 2.66602C8.63653 2.66602 2.66699 8.63555 2.66699 15.9993C2.66699 23.3631 8.63653 29.3327 16.0003 29.3327Z"
                stroke="#1E40AF"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M16 8V16L21.3333 18.6667" fill="#1E40AF" />
            <path d="M16 8V16L21.3333 18.6667" stroke="#1E40AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <CheckCircle2 class="min-w-6 text-green-600" v-if="variant === 'paid'" />
        <div>
            <Primitive :as="props.as" :class="cn(paymentTitleHeader({ variant: props.variant }), props.class)" :variant="props.variant">
                <slot />
            </Primitive>

            <p class="mt-2.5 text-sm text-slate-600">
                <slot name="description" />
            </p>
        </div>
    </div>
</template>
